module.exports = "<aside class=\"al-sidebar\" sidebarResize>\r\n  <ba-menu [menuHeight]=\"menuHeight\"\r\n           [sidebarCollapsed]=\"isMenuCollapsed\"\r\n           (expandMenu)=\"menuExpand()\"></ba-menu>\r\n</aside>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/components/baSidebar/baSidebar.html
// module id = 666
// module chunks = 16